import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function PageHeader({
  headerContent,
  onClick,
  showBackArrowButton,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: (theme) => theme.spacing(7),
        minHeight: (theme) => theme.spacing(7),
        width: '100%',
        px: 1,
      }}
    >
      {showBackArrowButton && (
        <IconButton onClick={onClick} sx={{ mx: 1 }}>
          <ArrowBackIcon />
        </IconButton>
      )}
      {headerContent}
    </Box>
  );
}

PageHeader.defaultProps = {
  onClick: null,
};

PageHeader.propTypes = {
  headerContent: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  showBackArrowButton: PropTypes.bool.isRequired,
};

export default PageHeader;
